import React, { memo } from 'react';
import type { FunctionComponent, MouseEvent } from 'react';
import { Loader } from '@shared-components';
import './RadioList.scss';
import { RadioButtonGroup, RadioButton } from '@web-components-proxy';

export interface RadioListProps {
	items: string[];
	changeHandler: (e: MouseEvent) => void;
}

export const RadioList: FunctionComponent<RadioListProps> = memo(({ items, changeHandler }) => {
	if (!items.length) {
		return <Loader fullscreen={false} size="small" />;
	}
	return (
		<RadioButtonGroup class="radio-list" name="items" onClick={changeHandler}>
			{items.map((item, index) => (
				<RadioButton key={index} display-mode="block" name="items" value={item}>
					{item}
				</RadioButton>
			))}
		</RadioButtonGroup>
	);
});
